import React, {useEffect, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'

import Box from '../../component/Box/Box'
import Page from '../../component/Page/Page'
import Notify from '../../services/Notify'
import FormButtons from '../../component/Form/FormButtons'
import AssetService from '../../services/AssetService'
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem'
import ProductTypeSelector, {mapItems} from '../../productType/component/ProductTypeSelector'
import {InputWithLabel} from '../../component/Form/InputWithLabel'
import {AuditingService} from "../../services/AuditingService";
import LoadingV2 from '../../component/Loading/LoadingV2'
import TodoList from '../../component/List/TodoList'

function AuditPage({history, match}) {

  const {epc} = match.params

  const [lot, setLot] = useState(null)
  const [asset, setAsset] = useState(null)
  const [epcs, setEpcs] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [productType, setProductType] = useState(null)

  const assetService = new AssetService()
  const auditingService = new AuditingService();

  const loadAssetByEpc = async () => {
    setIsLoading(true)
    try {
      setAsset(await assetService.findByEpc(epc))
    } catch (error) {
      Notify.error('Erro', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadAssetByEpc()
  }, [])

  const validateEpcs = async (value) => {
    const result = await assetService.validateEpc(asset.id, [{ value }]);
    const {valid} = result.epcs && result.epcs[0]

    if (!valid) {
      throw new Error('Este EPC não é válido')
    }
  }

  useEffect(() => {
    if (!asset) {
      return;
    }

    asset.tags && setEpcs(asset.tags)

    setLot(asset.lot && asset.lot.code)
    setProductType(asset.productType)
  }, [asset]);

  const createAuditing = async () => {
    try {
      const body = {
        tags: epcs,
        lot: {
          code: lot
        },
        productType: {
          id: productType.id
        }
      }

      await auditingService.saveAuditing(asset.id, body);

      Notify.success('Produto auditado!');
      history.push(`/track/${epcs && epcs[0].value}`);
    } catch (e) {
      Notify.error('Falha ', e);
    }
  }

  const auditingAsset = async () => {
    setIsLoading(true);
    try {

      if (!epcs.length > 0) {
        throw new Error("Não é possivel auditar produto sem EPC's")
      }

      await createAuditing();
    } catch (e) {
      Notify.error('Erro ao auditar', e);
    } finally {
      setIsLoading(false);
    }
  }

  const onSubmit = (event) => {
    event.preventDefault();
    auditingAsset();
    return false;
  }

  const breadcrumbs = [<BreadcrumbItem key={1} title="Detalhes do produto" to={`/track/${epc}`} />]

  return (
    <Page title="Auditar" breadcrumbs={breadcrumbs}>
      <LoadingV2 isLoading={isLoading}>
        <Box title="Audite seu produto">
          <Form onSubmit={(e) => onSubmit(e)}>
            <Row>
              <Col md={6}>
                <ProductTypeSelector
                  required
                  defaultValue={productType && mapItems(productType)}
                  onChange={setProductType}
                />
              </Col>
              <Col md={6}>
                <InputWithLabel
                  label="Lote"
                  placeholder="Digite o Lote"
                  inputType="text"
                  defaultValue={lot || ''}
                  onChange={e => setLot(e.target.value)}
                  required
                />
              </Col>
              <Col md={12}>
                <TodoList title="Lista de EPC's" data={epcs} getItems={epcs => setEpcs(epcs)} onSaveItem={validateEpcs}/>
              </Col> 
              <Col md={12} className="mt-5">
                <FormButtons history={history} />
              </Col>
            </Row>
          </Form>
        </Box>
      </LoadingV2>
    </Page>
  )
}

export {AuditPage}



// WEBPACK FOOTER //
// ./src/pages/AuditPage/AuditScreen.js